export const BOOKING_TIME_ZONE = "America/New_York";

export const CANCELLATION_CUTOFF_HOURS = 24;

export const CANCELLATION_CUTOFF_MESSAGE = "Cancelling or rescheduling closes 24 hours before the appointment.";

export type ScheduledVisit = { date: string; time: string | null | undefined };

const HOUR_MS = 3_600_000;

const bookingWallClock = new Intl.DateTimeFormat("en-US", {
  timeZone: BOOKING_TIME_ZONE,
  hourCycle: "h23",
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
});

function wallClockOffsetAt(instant: number): number {
  const part = Object.fromEntries(bookingWallClock.formatToParts(new Date(instant)).map(({ type, value }) => [type, Number(value)]));
  const wallClockAsUtc = Date.UTC(part.year!, part.month! - 1, part.day!, part.hour!, part.minute!, part.second!);
  return wallClockAsUtc - instant;
}

function timeOfDay(time: string | null | undefined): [number, number, number] {
  const match = /^(\d{2}):(\d{2})(?::(\d{2}))?/.exec(time ?? "");
  return match ? [Number(match[1]), Number(match[2]), Number(match[3] ?? 0)] : [0, 0, 0];
}

export function appointmentStartsAt({ date, time }: ScheduledVisit): Date {
  const [year, month, day] = date.split("-").map(Number);
  const wallClockAsUtc = Date.UTC(year!, month! - 1, day!, ...timeOfDay(time));
  const guess = wallClockAsUtc - wallClockOffsetAt(wallClockAsUtc);
  return new Date(wallClockAsUtc - wallClockOffsetAt(guess));
}

export function withinCancellationCutoff(visit: ScheduledVisit, now: Date = new Date()): boolean {
  return appointmentStartsAt(visit).getTime() - now.getTime() < CANCELLATION_CUTOFF_HOURS * HOUR_MS;
}

const twoDigits = (value: number) => String(value).padStart(2, "0");

export function bookingDayOf(at: Date): string {
  const part = Object.fromEntries(bookingWallClock.formatToParts(at).map(({ type, value }) => [type, Number(value)]));
  return `${String(part.year).padStart(4, "0")}-${twoDigits(part.month!)}-${twoDigits(part.day!)}`;
}

export function isAfterBookingToday(day: string, now: Date = new Date()): boolean {
  return day > bookingDayOf(now);
}
